import { render, staticRenderFns } from "./DisclosurePayers.vue?vue&type=template&id=64bbf0cc&scoped=true&"
import script from "./DisclosurePayers.vue?vue&type=script&lang=ts&"
export * from "./DisclosurePayers.vue?vue&type=script&lang=ts&"
import style0 from "./DisclosurePayers.vue?vue&type=style&index=0&id=64bbf0cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bbf0cc",
  null
  
)

export default component.exports